import React, { useEffect, useState } from "react";
import { adminService } from "../../services/admin.service";
import "./adminEmailCampaign.css";

const AdminEmailCampaignPage = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [customers, setCustomers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sendToAll, setSendToAll] = useState(true);

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [isError, setIsError] = useState(false);

  // 🔥 Load customers with order count
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const data = await adminService.getCampaignCustomers();
        setCustomers(data);
      } catch (err) {
        console.error("Failed to fetch customers");
      }
    };

    fetchCustomers();
  }, []);

  const toggleUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id)
        ? prev.filter((u) => u !== id)
        : [...prev, id]
    );
  };

  const sendCampaign = async () => {
    try {
      setLoading(true);
      setResponseMsg("");
      setIsError(false);

      const res = await adminService.sendEmailCampaign({
        subject,
        message,
        selectedUserIds: sendToAll ? [] : selectedUsers,
      });

      setResponseMsg(res.message || "Campaign sent successfully!");
      setSubject("");
      setMessage("");
      setSelectedUsers([]);
    } catch (err) {
      setIsError(true);
      setResponseMsg(
        err.response?.data?.error || "Failed to send campaign"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="campaign-layout">
      
      {/* LEFT SIDE */}
      <div className="campaign-left">
        <div className="campaign-card">
          <h2>📢 Email Campaign</h2>

          <div className="form-group">
            <label>Subject</label>
            <input
              type="text"
              placeholder="Enter campaign subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea
              rows="6"
              placeholder="Write your campaign message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>

          <div className="send-options">
            <label>
              <input
                type="checkbox"
                checked={sendToAll}
                onChange={() => setSendToAll(!sendToAll)}
              />
              Send to All Customers
            </label>

            {!sendToAll && (
              <p className="selected-count">
                Selected: {selectedUsers.length}
              </p>
            )}
          </div>

          <button
            className="send-btn"
            onClick={sendCampaign}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Email Campaign"}
          </button>

          {responseMsg && (
            <div
              className={`response-msg ${
                isError ? "response-error" : "response-success"
              }`}
            >
              {responseMsg}
            </div>
          )}
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="campaign-right">
        <div className="customers-card">
          <h3>Customers</h3>

          {!sendToAll && (
            <div className="customer-list">
              {customers.map((c) => (
                <div key={c.user_id} className="customer-item">
                  <input
                    type="checkbox"
                    checked={selectedUsers.includes(c.user_id)}
                    onChange={() => toggleUser(c.user_id)}
                  />

                  <div className="customer-info">
                    <div className="customer-name">
                      {c.first_name} {c.last_name}
                    </div>
                    <div className="customer-orders">
                      Orders: {c.totalOrders}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {sendToAll && (
            <p className="all-selected-msg">
              Campaign will be sent to all customers.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminEmailCampaignPage;